var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScheduleFixed100 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 12,
    width: 12,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4,
    stroke: "#FFFF4D",
    strokeWidth: 1.5,
    fill: "#FFFE4D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleFixed100);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-fixed-100.cc8bfb819538febe04e6ac9d61bf8995.svg";